import React from 'react';

export default () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.5209 10H10.4792C10.9251 10 11.148 9.46042 10.8334 9.14583L8.35423 6.66667C8.1584 6.47083 7.84173 6.47083 7.64798 6.66667L5.16673 9.14583C4.85215 9.46042 5.07507 10 5.5209 10Z'
      fill='#29B51C'
    />
  </svg>
);
